import http from '@/plugins/axios/axios';

export default class EmpresaService {

    listarEstados() {        
        return http.get('/api/empresa/listar-estados');
    }

    listarCidades(idEstado) {       
        return http.get('/api/empresa/listar-cidades/'+idEstado);
    }

    listar(valorBusca, pagina, totalPorPagina) {
        const filtro = typeof valorBusca === 'string' ? valorBusca.toLowerCase() : valorBusca;
        return http.get(`/api/adm/empresa/listar?valor=${filtro || ''}&pagina=${pagina}&totalPorPagina=${totalPorPagina}`);
    } 

    listarCnpj(valorBusca, pagina, totalPorPagina) {
        const filtro = typeof valorBusca === 'string' ? valorBusca.toLowerCase() : valorBusca;
        return http.get(`/api/adm/empresa/listar-cnpj?valor=${filtro || ''}&pagina=${pagina}&totalPorPagina=${totalPorPagina}`);
    }

    buscar(requisicao) {       
        return http.post('/api/adm/empresa/buscar', requisicao);
    }

    salvar(requisicao) {       
        return http.post('/api/adm/empresa/salvar', requisicao);
    }

    trocarPlano(requisicao) {
        return http.post('/api/adm/empresa/trocar-plano', requisicao);
    }
    
    editarStatus(requisicao) {
        return http.post('/api/adm/empresa/editar-status', requisicao);
    }

    buscarClientes(requisicao) { 
        return http.post('/api/adm/empresa/buscar-clientes-status', requisicao);
    }

    listarClientes(request) {
        return http.post('/api/adm/empresa/listar-clientes', request);
    }

    listarFiltros() {
        return http.get('/api/adm/empresa/filtros');
    }

    exportarCsv(request, tipo) {
        if('GERAL' == tipo) {
            return http.post('/api/adm/empresa/exportar-csv-clientes-geral', request);
        }
        // ULTIMO_ACESSO
        return http.post('/api/adm/empresa/exportar-csv-clientes-ulitmo-acesso', request);
    }
    
}